import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page26/Key/E2answerKey.jpg",
    component: T6,
    isHiddenCheck: true,
   
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Di chuyển thước vào các góc trong hình để đo rồi nháy chuột vào chỗ chấm để điền số đo.</span>
        <video src="Audios/bt_fpt_ai/guide/p26_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "355px",
        inputTop: "340px",
        ResultProtractor:[
          {
            textResult: 90,
            styleResult:{
              top: -206,
              left:12
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-121,
              left:-311
            },
          },
          {
            textResult: 60,
            styleResult:{
              top:-324,
              left:-172
            }
          },
          {
            textResult: 60,
            styleResult:{
              top:-137,
              left:-62
            },
          },
          {
            textResult: 30,
            styleResult:{
              top:-242,
              left:-57
            }
          },
          {
            textResult: 30,
            styleResult:{
              top:-138 ,
              left:-85
            },
          },
        ],
        result: [
          //Đỉnh A
          {
            id: 0,
            top: -158, // top cây thước sau khi đặt vô hình
            left: -6, // left cây thước sau khi đặt vô hình
            rotate: 121,
          },
          {
            id: 1,
            top: -158, // top cây thước sau khi đặt vô hình
            left: -6, // left cây thước sau khi đặt vô hình
            rotate: -151,
          },
          //Đỉnh B
          {
            id: 2,
            top: 17, // top cây thước sau khi đặt vô hình
            left: -110, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 3,
            top: 16, // top cây thước sau khi đặt vô hình
            left: -111, // left cây thước sau khi đặt vô hình
            rotate: 120,
          },
          //Đỉnh C
          {
            id: 4,
            top: 15, // top cây thước sau khi đặt vô hình
            left: 312, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 5,
            top: 13, // top cây thước sau khi đặt vô hình
            left: 312, // left cây thước sau khi đặt vô hình
            rotate: -151,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "2",
        title: `Dùng thước đo góc để đo các góc rồi viết vào chỗ chấm.
		    `,
        color: "rgb(99,197,244)",
      },
    ],

    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style="position: absolute; top: -47px; left: 0px">
        <img src="/img/FriendsPlus/Page26/E2/1.jpg"  style="height:7cm;margin-top:50px;position:absolute;top:0px;left:0px" >
        
        
        

        <div
          style="
            position: absolute;
            left: 188px;
            top: 92px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 82px;
            top: 267px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 505px;
            top: 266px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
      </div>


      <div
          id="protractor"
          style="position: absolute;top: 226px;left: -51px;width: 400px; height: 420px;z-index: 1"
        >
        <img
        src="/img/test/protractor-removebg-preview3.png"
        style="width: 400px"
        alt="image"
      />
        </div>

        <div style="position: absolute;top: 0px;left: 500px;width:500px;height:300px">
      	<span style=''>Góc đỉnh A; cạnh AB, AC bằng <input id= "0"><sup>o</sup></span><br>
      	<span style=''>Góc đỉnh B; cạnh BA, BC bằng <input id= "1"><sup>o</sup></span><br>
      	<span style=''>Góc đỉnh C; cạnh CA, CB bằng <input id= "2"><sup>o</sup></span>
      </div>
        `,
        answer: ["90", "60", "30"],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page26/Key/E3answerKey.jpg",
    component: T6,
    isHiddenCheck: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Di chuyển thước vào các góc trong hình để đo rồi nháy chuột vào chỗ chấm để điền số đo.</span>
        <video src="Audios/bt_fpt_ai/guide/p26_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "970px",
        inputBottom: "400px",
        result: [
          //Clock A
          {
            id: 0,
            top: -77, // top cây thước sau khi đặt vô hình
            left: -57, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 1,
            top: -77, // top cây thước sau khi đặt vô hình
            left: -58, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          //Clock B
          {
            id: 2,
            top: -77, // top cây thước sau khi đặt vô hình
            left: 189, // left cây thước sau khi đặt vô hình
            rotate: -30,
          },
          {
            id: 3,
            top: -77, // top cây thước sau khi đặt vô hình
            left: 189, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          //Clock C
          {
            id: 4,
            top: -77, // top cây thước sau khi đặt vô hình
            left: 438, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          {
            id: 5,
            top: -77, // top cây thước sau khi đặt vô hình
            left: 438, // left cây thước sau khi đặt vô hình
            rotate: 30,
          },

          //Clock D
          {
            id: 6,
            top: -77, // top cây thước sau khi đặt vô hình
            left: 683, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          {
            id: 7,
            top: -77, // top cây thước sau khi đặt vô hình
            left: 683, // left cây thước sau khi đặt vô hình
            rotate: -90,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "3",
        title: `Dùng thước đo góc để đo góc được tạp bởi hai kim đồng hồ.
		    `,
        color: "rgb(99,197,244)",
      },
    ],

    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
       
        <div style="position: relative; ">
        <img src="/img/FriendsPlus/Page26/E3/1.jpg"  style="height:7cm;" >
        
        <div style='margin-left:150px; position: absolute;  left: -26px; top: -55px;z-index:10' >
          <div id="result-0" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >90</span>
          </div>
        </div>
        <div style='margin-left:150px; position: absolute;  left: 193px; top: 103px;z-index:10' >
          <div id="result-1" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >90</span>
          </div>
        </div>

        <div style='margin-left:150px; position: absolute;  left:219px; top: -56px;z-index:10' >
          <div id="result-2" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >60</span>
          </div>
        </div>
        <div style='margin-left:150px; position: absolute;  left:414px; top: 0px;z-index:10' >
          <div id="result-3" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >60</span>
          </div>
        </div>

        <div style='margin-left:150px; position: absolute;  left: 657px; top: 221px;z-index:10' >
          <div id="result-4" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >120</span>
          </div>
        </div>
        <div style='margin-left:150px; position: absolute;  left:461px; top: -103px;z-index:10' >
          <div id="result-5" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >120</span>
          </div>
        </div>

        <div style='margin-left:150px; position: absolute;  left: 706px; top: 331px;z-index:10' >
          <div id="result-6" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >180</span>
          </div>
        </div>
        <div style='margin-left:150px; position: absolute;  left:705px; top: -103px;z-index:10' >
          <div id="result-7" style='background: rgb(89 188 141);  border-radius: 50%; color: white;padding: 2px 6px; text-align:center;display:none; '>
            <span 
            >180</span>
          </div>
        </div>
        

        <div
          style="
            position: absolute;
            left: 135px;
            top: 128px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 383px;
            top: 128px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 631px;
            top: 128px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 876px;
            top: 128px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 225px;left: 595px;width: 400px; height: 420px;z-index: 1"
        >
        <img
        src="/img/test/protractor-removebg-preview3.png"
        style="width: 400px"
        alt="image"
      />
      </div>
      <div style='position:absolute;top:280px;left:0px; display:flex; margin-bottom: 50px'>
        <div style='font-size:25px;color:rgb(99,197,244); margin-right:10px'>
          <b>a)</b>
        </div>
        <b>Viết số đo góc vào chỗ chấm cho thích hợp.</b>
      </div>
      <div style='width: 1000px; height: 300px'>
      <div style='margin-top: 80px; line-height: 50px'>
      	<span style=''>Hai kim đồng hồ A tạo ra góc <input id= "0"><sup>o</sup></span><br>
      	<span style=''>Hai kim đồng hồ B tạo ra góc <input id= "1"><sup>o</sup></span><br>
      	<span style=''>Hai kim đồng hồ C tạo ra góc <input id= "2"><sup>o</sup></span><br>
        <span style=''>Hai kim đồng hồ D tạo ra góc <input id= "3"><sup>o</sup></span>
      </div>
      </div>
        `,
        answer: ["90", "60", "120", "180"],
      },
    ],
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page26/Key/E4answerKey.png",

    titleQuestion: [
      {
        num: "b)",
        title: `Khoanh vào chữ đặt dưới đồng hồ có hai kim đồng hồ tạo ra góc có số đo lớn nhất.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        
        <p>
         Nội dung tra cứu đang cập nhật..........
        </p>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chữ đặt dưới đồng hồ có hai kim đồng hồ tạo ra góc có số đo lớn nhất.</span>
        
        `,
      },
    ],
    component: Circle_Write,
    // totalInput: 1,
    isHiddenCheck: false,
    // Recorder: true,
    titleImage: "",
    // inputSize: 70,
    // isAllowSubmit: true,
    questionImage: [],
    stylesTextInput: {
      textAlign: "center",
      fontSize: 23,
    },
    question: {
      Write: {
        inputStyle: {
          width: 100,
          fontSize: 22,
          textAlign: "center",
          maxLength: 3,
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          borderRadius: "50%",
          fontWeight: "bold",
          borderColor: "transparent",
          border: "2px solid white",
          padding: "0px 4px",
        },
        selectWordStyle: {
          padding: "0px 4px",
          border: "2px solid black",
        },
        limitSelect: 1,
        listWords: [
          `A &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
         B &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
         C &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
         D
         `, //1
        ],
        answers: ["0-66"],
        initialValue: [],
      },
      Layout: `
        <div style="">
           <img src='/img/FriendsPlus/Page26/E4/1.jpg' style='height:7cm; width: 25cm'/>
           <div style= "margin-left: 114px"><input id='0' type='Circle'/></div>  
        </div>
    `,
    },
  },
};

export default json;
